module.exports = __webpack_public_path__ + "img/prize1.599c7b82.png";